import { TextField } from '@material-ui/core';
import { useField } from 'formik';
import React, { useState } from 'react';

let isError = false;
const TextfieldWrapper = ({ name, type, ...otherProps }) => {
    const [field, mata] = useField(name);
    const { onBlur: formikOnBlur, ...fieldRest } = field;
    const { sendDataToInput, sendDataOnBlur, ...restOtherProps } = otherProps;
    // const classes = useStyles();
    const [isSelected, setIsSelected] = useState(false);
    const numberInputOnWheelPreventChange = (e) => {
        e.target.blur();
        e.stopPropagation();
        setTimeout(() => {
          e.target.focus();
        }, 0);
      };
      const configTextfield = {
        ...fieldRest,
        ...restOtherProps,
        fullWidth: true,
        id:name?name: 'standard-basic',
        onBlur: (e) => {
          formikOnBlur(e);
          if (sendDataOnBlur) sendDataOnBlur(e);
        },
    };
    const changeEvent = (e) => {
       
    };
    const changeOnKeyUp = (e) => {
             if (sendDataToInput) sendDataToInput(e);

    };
    if (mata && mata.touched && mata.error) {
        configTextfield.error = true;
        configTextfield.helperText = mata.error;
        isError = true;
    }
    // if (mata && mata.touched && !mata.error) {
    //   //configTextfield.helperText = style(colors.lightGreen);
    //   configTextfield.helperText = "Success";
    //   configTextfield.FormHelperTextProps = {
    //     className: classes.MuiFormHelperText,
    //   };
    // }

    // const iconAdornment = isSelected
    //   ?
    // {
    //       endAdornment: (
    //         <InputAdornment position="end">
    //           <CheckIcon></CheckIcon>
    //         </InputAdornment>
    //       ),
    //     }
    //   : isError
    //   ? {
    //       endAdornment: (
    //         <InputAdornment position="end">
    //           <ErrorOutlineIcon></ErrorOutlineIcon>
    //         </InputAdornment>
    //       ),
    //     }
    //   : {};

    //   InputProps={iconAdornment}

    return (
        <TextField
            type={type}
            onChange={changeEvent}
            onKeyUp={changeOnKeyUp}
            onWheel={numberInputOnWheelPreventChange}
            {...configTextfield}
        />
    );
};

export default TextfieldWrapper;
